import { render } from "./ListMethod.vue?vue&type=template&id=5b95cf26&scoped=true"
import script from "./ListMethod.vue?vue&type=script&lang=js"
export * from "./ListMethod.vue?vue&type=script&lang=js"

import "./ListMethod.vue?vue&type=style&index=0&id=5b95cf26&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b95cf26"]])

export default __exports__